/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Result_Unknown_DetailInputs */



/**
* | output |
* | --- |
* | "oneAI could not tell whether this action was carried out. Check the target system before trying again." |
*
* @param {Chat_Tool_Result_Unknown_DetailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_result_unknown_detail = /** @type {((inputs?: Chat_Tool_Result_Unknown_DetailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Result_Unknown_DetailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI konnte nicht feststellen, ob diese Aktion ausgeführt wurde. Prüfen Sie das Zielsystem, bevor Sie es erneut versuchen.")
	return /** @type {LocalizedString} */ ("oneAI could not tell whether this action was carried out. Check the target system before trying again.")
});